import { render, staticRenderFns } from "./CustomerQuotation.vue?vue&type=template&id=1a0c1fe8"
import script from "./CustomerQuotation.vue?vue&type=script&lang=js"
export * from "./CustomerQuotation.vue?vue&type=script&lang=js"
import style0 from "./CustomerQuotation.vue?vue&type=style&index=0&id=1a0c1fe8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports